// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_1ytwE","wrapper":"view-header_wrapper_2TZaA","button":"view-header_button_24A42","active":"view-header_active_1aSvB","hidden":"view-header_hidden_3b9u6"};